import { ApolloClient } from '@apollo/client';
import { Button, Grid } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { Org, OrgFragment, OrgType } from '../lib/verid-api/verid-api-types';
import { useOrgService } from '../lib/verid-api/use-org-service';

interface IProps {
  readFromVerid?: boolean;
  selectOrg: (orgId: string) => void;
}

const cssClasses = {
  btnPrimary: {
    padding: `16px 8px`,
  },
  btnHolder: {
    width: '100%',
    marginBottom: '16px',
  },
};

const DEBUG = false;

export function OrgSelector(props: IProps) {
  const { readFromVerid, selectOrg } = props;
  const [orgs, setOrgs] = useState<OrgFragment[]>([]);

  const orgService = useOrgService();

  useEffect(() => {
    orgService
      .getOrgs({
        type: OrgType.PROVIDER,
      })
      .then((response) => {
        const result = response.data?.getAllOrgs;
        DEBUG && console.debug('OrgSelector', 'getOrgs response', { response, result });

        if (result && result.length > 0) {
          setOrgs(result);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      });
  }, []);

  DEBUG && console.debug('OrgSelector', 'render', { orgs });
  return (
    <>
      {orgs.map((org) => {
        return (
          <Grid container flexDirection="column" alignItems="center" key={org.id}>
            <Box my={1} sx={cssClasses.btnHolder}>
              <Button sx={cssClasses.btnPrimary} variant="contained" fullWidth={true} color="primary" onClick={() => selectOrg(org.id)}>
                {org.name}
              </Button>
            </Box>
          </Grid>
        );
      })}
    </>
  );
}
